module.exports = __webpack_public_path__ + "static/img/logo.f267112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/logo.png
// module id = EjUi
// module chunks = 2